import slideshow from './slideshow';
import videoText from './videoText';

export default function videoWidget1() {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;
  const $widget = $(`#${widgetName}`);

  const addVideoTag = false;
  const tagText = 'Watch';

  $widget.append('<iframe></iframe>');
  $widget.wrap('<div id="videoSection"></div>');

  $widget.videoWidget({
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    autoPlayVideo: true,
    loopVideo: true, // autoPlayVideo must be enabled
    maxVideos: 1,

    videoWidgetLoaded: function (data) {
      if (data.Slides.length >= 1) {
        addVideoTag && $('#videoSection').append(`<div class="video-tag">${tagText}</div`);
        videoText();
        $('.slideshow-wrapper').remove();
      } else {
        slideshow();
        $('.video-container').remove();
      }
    },
  });
}
